import { render, staticRenderFns } from "./userExamDetail.vue?vue&type=template&id=498b51d5&scoped=true"
import script from "./userExamDetail.vue?vue&type=script&lang=js"
export * from "./userExamDetail.vue?vue&type=script&lang=js"
import style0 from "./userExamDetail.vue?vue&type=style&index=0&id=498b51d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498b51d5",
  null
  
)

export default component.exports